//检查文件上传状态
import {applicationName} from "../utils";
import request from "../base/request";

export const checkFileStatus = (md5, retry=true, retryCount=10, currentRetryCount=0) => new Promise((resolve, reject) => {
    let url = "/storage/getStorageFileStatus";
    let errorFun = (reject)=>{
        if(currentRetryCount < retryCount){
            checkFileStatus(md5, retry, retryCount, ++currentRetryCount);
        }else{
            reject();
        }
    };
    request({url, body:{md5}, loading:false, callBack:(res)=>{
        resolve(res)
    }, message:{
        info:()=>errorFun(reject),error:()=>errorFun(reject)
    }});
});